module.exports = __webpack_public_path__ + "img/greenbg.6345dd67.png";